import React from "react";
import PropTypes from "prop-types";
import style from "./product-description-price-history-bullet.css";

function ProductDescriptionPriceHistoryBullet({ className, priceHistoryBullet }) {
    return (
        <div className={className}>
            <h4 className={style.title}>
                {
                    "Price History" // TODO: i18n
                }
            </h4>
            <p>
                {priceHistoryBullet}
                {" " /* we need a single whitespace here */}
                <a className={style.anchor} href="#price-history">
                    {
                        "See price and stock history." // TODO: i18n
                    }
                </a>
            </p>
        </div>
    );
}

ProductDescriptionPriceHistoryBullet.propTypes = {
    className: PropTypes.string,
    priceHistoryBullet: PropTypes.string.isRequired,
};

export default ProductDescriptionPriceHistoryBullet;
